module.exports = __webpack_public_path__ + "static/media/tour-operator-icon.eae80fea.svg";